import { queryOptions } from '@tanstack/react-query'
import { authClient } from './auth-client'
import { queryClient } from './query-client'

export const queryKeys = {
  getSession: ['session'],
}

/**
 * Get currently logged in user session
 */
export const getSessionQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.getSession,
    queryFn: async () => {
      const session = await authClient.getSession()
      // Throw so the failure isn't cached as "signed out", and reaches the error page like a network failure
      if (session.error) {
        throw new Error(
          `Failed to get session: ${session.error.status} ${session.error.statusText}`,
        )
      }
      return session
    },
    staleTime: 3 * 60 * 1000, // 3 minutes
  })

/**
 * Invalidates the fetched user session data in the React Query cache, usually called after logging out
 */
export const invalidateSessionQuery = () => {
  queryClient.invalidateQueries({ queryKey: queryKeys.getSession })
}
